export default __webpack_public_path__ + "static/media/prescription-delivered.328bae4f.jpg";